const FinalCTA = () => {
  return (
    <section className="relative py-24 md:py-36 overflow-hidden" style={{ background: '#080808' }}>
      {/* Full-bleed cinematic background */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/199491e1ea08e186da513a1b9ccfb964.jpg"
          alt=""
          className="w-full h-full object-cover"
          style={{ opacity: 0.2 }}
        />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(8,8,8,0.6), rgba(8,8,8,0.9))' }} />
      </div>

      {/* Splatter decorations */}
      <div className="absolute top-0 left-0 w-96 h-96 pointer-events-none" style={{ background: 'radial-gradient(ellipse, rgba(255,67,34,0.12) 0%, transparent 70%)', borderRadius: '60% 40% 70% 30% / 50% 60% 40% 50%' }} />
      <div className="absolute bottom-0 right-0 w-80 h-80 pointer-events-none" style={{ background: 'radial-gradient(ellipse, rgba(255,179,0,0.09) 0%, transparent 70%)', borderRadius: '38% 62% 46% 54% / 60% 44% 56% 40%' }} />

      {/* Paint line at top */}
      <div className="absolute top-0 left-0 right-0 h-[2px]" style={{ background: 'linear-gradient(90deg, #ff4322, #ffb300, #ff7120, #e0285a, #ff4322)' }} />

      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 text-center">
        {/* Icon */}
        <div
          className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-8"
          style={{ background: 'rgba(255,67,34,0.15)', border: '1px solid rgba(255,67,34,0.35)' }}
        >
          <i className="ri-palette-2-line text-3xl text-artden-coral"></i>
        </div>

        <h2 className="font-cormorant font-medium text-white leading-[0.95] tracking-tight mb-6" style={{ fontSize: 'clamp(3rem, 7vw, 6rem)' }}>
          Ready to Create<br />
          <em className="font-light italic" style={{ color: '#ff4322' }}>Something Beautiful?</em>
        </h2>

        <p className="font-outfit text-white/55 text-lg max-w-2xl mx-auto leading-relaxed mb-10">
          Whether you're booking a class, planning a birthday party, or searching for the perfect gift — Art Den Studio in Nazareth, PA is ready for you.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="https://artdenstudio.com/calendar/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-artden-coral hover:brightness-110 text-white font-semibold px-8 py-4 rounded-full text-base transition-all whitespace-nowrap inline-flex items-center gap-2.5 w-full sm:w-auto justify-center"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-calendar-event-line"></i>
            </span>
            Book Your Class
          </a>
          <a
            href="/parties-events"
            className="border border-white/20 hover:border-white/50 text-white font-semibold px-8 py-4 rounded-full text-base transition-all whitespace-nowrap inline-flex items-center gap-2.5 w-full sm:w-auto justify-center"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-cake-3-line"></i>
            </span>
            Plan Your Party
          </a>
        </div>

        {/* Secondary links */}
        <div className="flex flex-wrap items-center justify-center gap-6 text-white/35 text-sm font-outfit">
          <a
            href="https://app.getoccasion.com/p/n/3mrk3shx9p7bhxywpcu9cg"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 hover:text-artden-amber transition-colors whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-gift-2-line"></i>
            </span>
            Buy a Gift Card
          </a>
          <span className="w-1 h-1 rounded-full bg-white/15" />
          <a
            href="tel:6103400314"
            className="flex items-center gap-1.5 hover:text-white transition-colors whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line"></i>
            </span>
            610-340-0314
          </a>
          <span className="w-1 h-1 rounded-full bg-white/15" />
          <a
            href="mailto:info@artdenstudio.com"
            className="flex items-center gap-1.5 hover:text-white transition-colors whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-line"></i>
            </span>
            info@artdenstudio.com
          </a>
          <span className="hidden sm:block w-1 h-1 rounded-full bg-white/15" />
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-map-pin-2-line"></i>
            </span>
            37 E Belvidere St, Nazareth, PA
          </span>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
